import { defaultOptions } from "../Options.js";
/**
 * Utility function that allows to filter files from a FileCollection ignores by default the dotFiles
 * @param relativePath - The relative path of the file to check
 * @param options - the filter options to use
 * @returns boolean
 */
export function shouldAddItem(relativePath, options = {}) {
    const { ignoreDotfiles = defaultOptions.filter.ignoreDotfiles, exclude, include, } = options;
    if (!ignoreDotfiles)
        return true;
    if (relativePath.startsWith('.'))
        return false;
    if (relativePath.includes('/.'))
        return false;
    if (exclude && isMatchAnyPattern(exclude, relativePath)) {
        return false;
    }
    if (include && !isMatchAnyPattern(include, relativePath)) {
        return false;
    }
    return true;
}
function isMatchAnyPattern(patterns, path) {
    if (Array.isArray(patterns)) {
        return patterns.some((pattern) => isMatchPattern(pattern, path));
    }
    return isMatchPattern(patterns, path);
}
function isMatchPattern(pattern, path) {
    if (typeof pattern === 'string') {
        return path.includes(pattern);
    }
    return pattern.test(path);
}
//# sourceMappingURL=shouldAddItem.js.map